import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: "Phone",
      label: "Call Us",
      value: "(416) 555-0123",
      action: "tel:+14165550123",
      description: "Monday to Saturday, 7 AM - 7 PM"
    },
    {
      icon: "Mail",
      label: "Email Us",
      value: "hello@montesantobakery.com",
      action: "mailto:hello@montesantobakery.com",
      description: "We respond within 24 hours"
    },
    {
      icon: "MessageCircle",
      label: "WhatsApp",
      value: "+1 (416) 555-0123",
      action: "https://wa.me/14165550123",
      description: "Quick responses during business hours"
    },
    {
      icon: "Instagram",
      label: "Instagram",
      value: "@montesantobakery",
      action: "https://instagram.com/montesantobakery",
      description: "Daily updates and specials"
    }
  ];

  return (
    <div className="bg-card rounded-2xl overflow-hidden shadow-warm">
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="MessageSquare" size={20} color="var(--color-primary)" />
          </div>
          <h2 className="text-2xl font-serif font-semibold text-foreground">
            Get In Touch
          </h2>
        </div>
        <p className="text-muted-foreground">
          Multiple ways to reach us for orders, inquiries, or just to say hello
        </p>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {contactMethods?.map((method, index) => (
            <a
              key={index}
              href={method?.action}
              target={method?.action?.startsWith('http') ? '_blank' : undefined}
              rel={method?.action?.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="group p-5 rounded-xl bg-muted/30 hover:bg-primary/5 border-2 border-transparent hover:border-primary/20 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-primary/10 group-hover:bg-primary/20 flex items-center justify-center flex-shrink-0 transition-colors">
                  <Icon name={method?.icon} size={22} color="var(--color-primary)" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-muted-foreground mb-1">
                    {method?.label}
                  </p>
                  <p className="font-medium text-foreground mb-1 truncate">
                    {method?.value}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {method?.description}
                  </p>
                </div>
                <Icon 
                  name="ExternalLink" 
                  size={16} 
                  className="text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0 mt-1"
                />
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6 p-5 bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl border border-primary/10">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Headphones" size={22} color="var(--color-primary)" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-2">
                Customer Support
              </h3>
              <p className="text-sm text-muted-foreground mb-3">
                Our friendly team is here to help with orders, custom cakes, catering inquiries, or any questions about our authentic Italian baked goods.
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background rounded-full text-xs font-medium text-foreground">
                  Custom Cakes
                </span>
                <span className="px-3 py-1 bg-background rounded-full text-xs font-medium text-foreground">
                  Catering
                </span>
                <span className="px-3 py-1 bg-background rounded-full text-xs font-medium text-foreground">
                  Special Orders
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;